import React, { useCallback, useState } from 'react';

import { Link } from '@ontruck/orc';

import { useOfferStats } from './hooks';
import JourneyOfferStatsModal from './Modal';

const t = {
  modal_title: 'Drivers who accepted the offer',
  accepted: 'accepted',
  rejected: 'rejected',
};

const JourneyOfferStats = ({ journeyId }) => {
  const statsData = useOfferStats(journeyId);
  const [modalOpened, setOpened] = useState(false);

  const openModal = useCallback(() => {
    setOpened(true);
  }, [setOpened]);

  const closeModal = useCallback(() => {
    setOpened(false);
  }, [setOpened]);

  if (!statsData) {
    return null;
  }

  const { accepted_count, rejected_count } = statsData;

  const acceptedText = `${accepted_count} ${t.accepted}`;
  const acceptedLink = <Link text={acceptedText} onClick={openModal} />;

  return (
    <>
      <div>
        {!!accepted_count ? acceptedLink : acceptedText} / {rejected_count} {t.rejected}
      </div>
      {modalOpened && (
        <JourneyOfferStatsModal journeyId={journeyId} onClose={closeModal} title={t.modal_title} />
      )}
    </>
  );
};

export default JourneyOfferStats;
